module.exports = __webpack_public_path__ + "static/img/detail_img_2.1ff44ca5.png";